import { renderCellDate } from "../../../../../utils/table-render-functions"
import { toDecimal } from "../../../MotorCadastros/utils/convert-fields"
import React from "react"
import {Typography} from "@mui/material"

const renderTwoLineHeader = (firstLine, secondLine) => (
    <Typography
        component="span"
        variant="contraHeading"
        sx={{
            display: "block",
            width: "100%",
            fontSize: "11px",
            lineHeight: "13.63px",
            textAlign: "center",
            whiteSpace: "normal",
        }}
    >
        {firstLine}<br />{secondLine}
    </Typography>
)

export const getColumnsTableEmissao = (isAdminUser) => [
    { field: "CETIP", headerName: "CETIP", minWidth: 130 },
    { field: "TipoAtivo", headerName: "Tipo Ativo", minWidth: 100 },
    { field: "DataEmissao", headerName: "Data Emissão", minWidth: 150, flex: 1, renderCell: (params) => renderCellDate(params) },
    { field: "DataVencimento", headerName: "Data Vencimento", minWidth: 140, flex: 1, renderCell: (params) => renderCellDate(params) },
    {
        field: "DataResgateAntecipado",
        headerName: "Data Resgate Antecipado",
        headerAlign: "center",
        align: "center",
        minWidth: 150,
        renderHeader: () => renderTwoLineHeader("Data Resgate", "Antecipado"),
        renderCell: (params) => renderCellDate(params),
    },
    { 
        field: "DataVencimentoAntecipado", 
        headerName: "Data Vencimento Antecipado", 
        headerAlign: "center",
        align: "center",
        minWidth: 150,
        renderHeader: () => renderTwoLineHeader("Data Vencimento", "Antecipado"),
        renderCell: (params) => renderCellDate(params) 
    },
    { field: "Indexador", headerName: "Indexador", minWidth: 150 },
    { field: "Remuneracao", headerName: "Remuneração", minWidth: 120, renderCell: (params) => toDecimal(params.value) }, //mudar field para Remuneracao
    ...(isAdminUser
        ? [{ field: "DataValidade_C2P", headerName: "Validade C2P", minWidth: 150, renderCell: (params) => renderCellDate(params) }]
        : []),
    { field: "Rating_C2P", headerName: "Score C2P", minWidth: 100 },
    { field: "Rating_Moodys", headerName: "Moody's", minWidth: 100 },
    { field: "Rating_Fitch", headerName: "Fitch", minWidth: 100 },
    { field: "Rating_SP", headerName: "S&P", minWidth: 100 },
]